// extracted by mini-css-extract-plugin
export var boxItems = "_a8-1";
export var boxItemsLg = "_a8-2";
export var button = "_a8-7";
export var buttonHoverless = "_a8-9";
export var buttonLg = "_a8-8";
export var filterGroupBox = "_a8-0";
export var icon = "_a8-3";
export var iconSecondary = "_a8-6";
export var iconWrapper = "_a8-4";
export var iconWrapperLg = "_a8-5";
export var truncatedLabel = "_a8-a";